export default __webpack_public_path__ + "static/media/eudelegation_dark.35992481.png";